import {css} from '@emotion/core';
import {fonts, breakpoints} from './vars';

export const resetFormElementStyles = css`
  font-family: ${fonts.regular};
  appearance: none;
  padding: 0;
  border: none;
  border-radius: 0;
  background: none;
  text-align: left;
  [lang='ar'] {
    text-align: right;
  }
`;

export let mq = {};

Object.keys(breakpoints).forEach((key) => {
  mq[key] = `@media (min-width: ${breakpoints[key]}px)`;
});

export const at = (breakpoint) => `@media (min-width: ${breakpoint}px)`;
